import { Controller } from 'stimulus'

import Rails from '@rails/ujs'
import axios from 'axios'

const DEBOUNCE_MS = 300

export default class extends Controller {
  static targets = ['select']

  connect() {
    axios.defaults.headers.common['X-CSRF-Token'] = Rails.csrfToken()

    // As some elements dispatch custom events, we need custom logic to listen.
    this.selectTargets.forEach((select) => {
      select.addEventListener('change', this.search.bind(this))
    })
  }

  search(event) {
    event.preventDefault()

    const form = event.currentTarget.closest('form')

    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => this.visit(form), DEBOUNCE_MS)
  }

  visit(form) {
    const params = new URLSearchParams()

    new FormData(form).forEach((value, key) => {
      params.append(key, value)
    })

    Turbo.visit(`${form.action}?${params.toString()}`, {
      action: 'replace',
      frame: 'filterable_v2_wrapper'
    })
  }
}
